<div class="container container--mobile-padding">
	<div class="person-block-parent"  [class.show]="personData">
		<div class="person-block" *ngIf="personData && personData.image_path">
			<ng-container>
				<div class="person-block__container">

					<div class="person-block__image">
						<img [src]="baseUrl + personData.image_path" [alt]="personData.name" [title]="personData.name">
					</div>
					<div class="person-block__text">
						<a class="person-block__close" [routerLink]="[backUrl, 'people']">
							<div class="icon icon--close-black"></div>
						</a>
						<p *ngIf="personData.description" class="person-block__desc" [innerHTML]="personData.description">
							{{personData.description}}
						</p>
						<div>
							<i class="person-block__name" *ngIf="personData.name">
								{{personData.name}}
							</i>
							<div class="person-block__position" *ngIf="personData.position">
								{{personData.position}}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
